import plTranslations from './pl.js';
import enTranslations from './en.js';
import deTranslations from './de.js';
import frTranslations from './fr.js';
import itTranslations from './it.js';
import fallbackTranslations from './fallback.js';

export default {
  'pl': plTranslations,
  'en': enTranslations,
  'de': deTranslations,
  'fr': frTranslations,
  'it': itTranslations,
  'fallback': fallbackTranslations
};
